import { encodeBase64Url } from './base64-url'
import { buildAssetName, buildRenderFileName } from './build-asset-name'
import { buildEndpoint, resolveEndpointUseSSL } from './build-endpoint'
import { buildNasDeliverablePath } from './build-nas-deliverable-path'
import { buildNasStagePlatformPath } from './build-nas-stage-platform-path'
import { buildOssCommentAttachmentPath } from './build-oss-comment-attachment-path'
import { buildOssPresetPath } from './build-oss-preset-path'
import { buildOssProjectPath } from './build-oss-project-path'
import { buildOssShapePath } from './build-oss-shape-path'
import { buildStorageObjectKey, stripStoragePrefix } from './build-storage-object-key'
import { clamp } from './clamp'
import { createPromise } from './create-promise'
import { createRace } from './create-race'
import { fileToBase64 } from './file-to-base64'
import { formatBytes } from './format-bytes'
import { formatDate } from './format-date'
import { formatDateTime } from './format-date-time'
import { formatDurationMs } from './format-duration'
import { formatRelativeTime } from './format-relative-time'
import { formatTimecode } from './format-timecode'
import { isMacosMetadataFile } from './is-macos-metadata-file'
import { isRecord } from './is-record'
import { isRenderOutputFileName } from './is-render-output-file-name'
import { mimeTypeByExtension } from './mime-type-by-extension'
import { normalizeText } from './normalize-text'
import { nowSeconds } from './now-seconds'
import { randomId } from './random-id'
import { sanitizeName } from './sanitize-name'
import { sleep } from './sleep'
import { sum } from './sum'

export const utils = {
  buildAssetName,
  buildRenderFileName,
  buildNasDeliverablePath,
  buildNasStagePlatformPath,
  buildOssPresetPath,
  buildOssProjectPath,
  buildOssShapePath,
  buildOssCommentAttachmentPath,
  buildStorageObjectKey,
  stripStoragePrefix,
  createPromise,
  createRace,
  fileToBase64,
  formatDate,
  formatDateTime,
  formatDurationMs,
  formatRelativeTime,
  formatTimecode,
  isMacosMetadataFile,
  isRenderOutputFileName,
  mimeTypeByExtension,
  randomId,
  sanitizeName,
  sleep,
  encodeBase64Url,
  nowSeconds,
  isRecord,
  buildEndpoint,
  resolveEndpointUseSSL,
  normalizeText,
  sum,
  clamp,
  formatBytes,
}
